const CardMainView = () => import('@/views/superadmin/card/CardMainView')
const CardsManagementView = () => import('@/views/superadmin/card/CardsManagementView')
const CardsBlockedView = () => import('@/views/superadmin/card/CardsBlockedView')
const CardsDeletedView = () => import('@/views/superadmin/card/CardsDeletedView')
const CardActionsView = () => import('@/views/superadmin/card/CardActionsView')

export default {
  path: 'cards',
  redirect: { name: 'CardsManagementSuperAdmin' },
  name: 'CardMainSuperAdmin',
  component: CardMainView,
  meta: { label: 'Карты' },
  children: [
    {
      path: 'management',
      name: 'CardsManagementSuperAdmin',
      component: CardsManagementView,
      meta: { label: 'Управление картами' },
    },
    {
      path: 'blocked',
      name: 'CardsBlockedSuperAdmin',
      component: CardsBlockedView,
      meta: { label: 'Блокированные карты' },
    },
    {
      path: 'deleted',
      name: 'CardsDeletedSuperAdmin',
      component: CardsDeletedView,
      meta: { label: 'Удалённые карты' },
    },
    {
      path: 'actions',
      name: 'CardActionsSuperAdmin',
      component: CardActionsView,
      meta: { label: 'Реестр действий с картой' },
    }
  ]
}